import {Avatar, DatePicker, Input, message, Radio, Tabs} from 'antd'
import classnames from 'classnames'
import FormActionBar from 'components/form/FormActionBar'
import {Formik, useFormikContext} from 'formik'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext, useState} from 'react'
import {NullAsDefault, shallowDiff} from 'views/Shared'
import {createControlledFormField} from "../../factory/createFormField";
import {createSelectValue, createValue} from "../../../../components/form/utils";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import TextArea from "antd/lib/input/TextArea";
import {ModalEditorToolbar} from "../../../SlateEditor/SlateEditor";
import SlateEditor, {SlateRenderer} from "../../../SlateEditor";
import {compose, mapProps, pure, withProps} from "recompose";
import {gConfigs} from "../../configs";
import {appClassNames} from "../../custom/appClassNames";
import withTranslate from "../../../../modules/local/withTranslate";
import {
    IoBusinessOutline,
    IoCalendarOutline,
    IoEarthOutline,
    IoImageOutline,
    IoPersonOutline,
    IoPricetagOutline,
    IoRibbonOutline,
    IoSchoolOutline,
    IoStarOutline,
} from "react-icons/io5";
import {formatDate, getDateString, parseDayjs} from "../../../../helpers/datetimeHelpers";
import {CountryPicker} from "../../User/functions/renderLocationCascade";
import {FeastStates} from "../../appFieldTypes";
import {convertFromString, convertToString} from "../../../SlateEditor/functions";
import {GiIronCross} from "react-icons/gi";
import PhotoField from "../../custom/PhotoField";
import Translate from "../../../../modules/local/Translate";
import {deepTranslate, renderIf, renderIfElse} from "../../../Shared";
import {isRawContentEmpty} from "../../../SlateEditor/functions/parseRawContent";
import EmptyHolder from "../../../../components/EmptyHolder";
import {RiDoubleQuotesL, RiDoubleQuotesR, RiMapPinFill, RiShareForwardFill} from "react-icons/ri";
import {SaintsFillSvg} from "../../../../components/Svgs/SaintsPlaceholder";
import {FaCircle} from "react-icons/fa6";
import LookupField from "../../../../components/LookupField";
import {PiLinkSimpleBold, PiPlusBold, PiWarningDuotone} from "react-icons/pi";
import {RequiredSystemAdmin} from "../../../../components/RequiredAdmin";
import {useFeedback} from "../../Feedback/functions/useFeedback";
import {BsPersonLinesFill, BsPersonWorkspace} from "react-icons/bs";
import {HeaderButton} from "../../../Organization/components/PageHeader";
import {callNativeShare} from "../../../../helpers";
import getTitle from "../../../../helpers/getTitle";
import {getAbsoluteLinkToDetail} from "../../../../helpers/getLinkToDetail";
import copyToClipboard from "copy-to-clipboard";
import {MdChurch} from "react-icons/md";
import {showDeleteConfirmDialog} from "../../factory/createConfirmDialog";
import {SelectWidget} from "../../custom/ReactSelectComponents";
import {BiTrash} from "react-icons/bi";
import {GoDotFill} from "react-icons/go";
import dayjs from "dayjs";
import {profileCategories} from "../consts/profileCategories";
import {ActionModalWrapper} from "../../../../components/form/ActionModalWrapper";
import {ChipGroup, Field, FormActions, Section} from "../../../../components/form/ModernForm";

const AliasNames = ({name, value, defaultValue = [], handleChange = NullAsDefault}) => {
    const t = useTranslate()
    const alias_names = value || defaultValue;
    const [newValue, setNewValue] = useState({
        language: 'vi',
        name: null,
    })

    return (
        <div className="flex flex-col gap-3">
            <div className="grid grid-cols-2 md:grid-cols-3 gap-3 flex-1">
                <div className="col-span-1 flex gap-3">
                    <SelectWidget
                        value={newValue?.language}
                        allowClear={true}
                        className="w-full"
                        defaultValue="vi"
                        placeholder={t('language')}
                        optionFilterProp="label"
                        onChange={(value) => {
                            setNewValue({...newValue, language: value})
                        }}
                        options={[
                            {label: 'vi', value: 'vi'},
                            {label: 'en', value: 'en'},
                            {label: 'fr', value: 'fr'},
                            {label: 'es', value: 'es'},
                            {label: 'la', value: 'la'},
                            {label: 'it', value: 'it'},
                            {label: 'ko', value: 'ko'},
                        ].map(deepTranslate(t))}
                    />
                </div>
                <div className="col-span-1 md:col-span-2 flex gap-3">
                    <Input
                        className="flex-1"
                        placeholder={t('input common name')}
                        onChange={(e, ...rest) => {
                            setNewValue({...newValue, name: e.target.value})
                        }}
                    />
                    <Avatar
                        size={32}
                        icon={<PiPlusBold size={15} className="text-primary"/>}
                        className="flex flex-center bg-primary-50 hover:bg-primary-100 rounded-md cursor-pointer"
                        onClick={() => {
                            if (newValue?.name) {
                                let _alias_names = _.cloneDeep(alias_names);
                                _alias_names.push(newValue);
                                handleChange(_alias_names)
                                setNewValue({language: 'vi', name: null})
                            } else {
                                message.warning(
                                    <span className="font-medium italic">{t('please input common name')}</span>
                                )
                            }
                        }}
                    />
                </div>
            </div>
            {renderIf(
                alias_names.length > 0,
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-3 gap-y-2">
                    {alias_names.map((alias_name, idx) => {
                        const {language, name} = alias_name ?? {}
                        return (
                            <div key={idx}
                                 className="py-2 flex items-center custom-item-render custom-render-border relative">

                                <div className="space-x-1 leading-tight flex-1">
                                    <GoDotFill size={10} className="text-color-400"/>
                                    <span className="font-bold text-color-000 tracking-wide">
                                    {name}
                                </span>
                                    <span className="text-xs text-primary-400 italic whitespace-no-wrap">
                                    {`( ${t(language)} )`}
                                </span>
                                </div>

                                <BiTrash
                                    size={13}
                                    className="text-primary-200 hover:text-primary-700 cursor-pointer contextIcon"
                                    onClick={() => {
                                        let _alias_names = _.cloneDeep(alias_names);
                                        showDeleteConfirmDialog({
                                            translate: t,
                                            title: 'delete this common name',
                                            message: 'are you sure you want to delete this common name',
                                            onOk: () => {
                                                _.remove(_alias_names, {id: alias_name?.id});
                                                handleChange(_alias_names)
                                            },
                                        });
                                    }}
                                />
                            </div>
                        )
                    })}
                </div>
            )}
        </div>
    )
}

const formSchema = {
    name: {
        title: 'real name',
        children: [
            {
                name: 'name',
                component: createControlledFormField({
                    placeholder: 'character name',
                }),
            },
        ],
    },
    alias_names: {
        title: 'common name',
        children: [
            {
                name: 'alias_names',
                component: createControlledFormField({
                    className: 'w-full',
                    Component: AliasNames,
                    withProps: ({name, value, onChange}) => ({
                        defaultValue: value,
                        handleChange: (_value) => {
                            onChange(createValue(name, _value))
                        }
                    }),
                    withValues: ({resetKey}) => ({
                        resetKey,
                    }),
                }),
            },
        ],
    },
    brief: {
        title: 'motto',
        children: [
            {
                name: 'brief',
                component: createControlledFormField({
                    placeholder: 'motto placeholder',
                    className: 'scrollBarThin custom-area-count',
                    Component: TextArea,
                    showCount: true,
                    maxLength: 500,
                    autoSize: {minRows: 3, maxRows: 6},
                }),
            },
        ],
    },
    notes: {
        title: 'notes',
        children: [
            {
                name: 'notes',
                component: createControlledFormField({
                    placeholder: 'notes',
                    className: 'scrollBarThin custom-area-count',
                    Component: TextArea,
                    showCount: true,
                    maxLength: 5000,
                    autoSize: {minRows: 3, maxRows: 5},
                }),
            },
        ],
    },
    about: {
        title: 'about character',
        children: [
            {
                name: 'about',
                component: createControlledFormField({
                    Component: SlateEditor,
                    ToolbarComponent: ModalEditorToolbar,
                    withProps: ({value}) => ({
                        defaultValue: value,
                    }),
                    withValues: ({resetKey}) => ({
                        resetKey,
                    }),
                }),
            },
        ],
    },
    photo__insignia: {
        inline: true,
        className: 'grid grid-cols-1 md:grid-cols-2 gap-3',
        itemClassNames: ['','hidden md:block'],
        children: [
            {
                label: 'portrait photo',
                name: 'photo',
                component: ({name, value, form, onChange}) => (
                    <LayoutContext.Consumer>
                        {({isSm}) => (
                            <Translate>
                                {(t) => (
                                    <div className="flex flex-col gap-2">
                                        <span className="text-xs text-color-500 italic">{`* ${t('description size avatar')}`}</span>
                                        <PhotoField
                                            Wrapper={({children}) => (
                                                <div className="flex flex-col flex-center relative">
                                                    {children}
                                                </div>
                                            )}
                                            className="background"
                                            cropPurpose="portrait"
                                            style={{
                                                padding: 0,
                                                minWidth: isSm ? 200 : 230,
                                                maxWidth: isSm ? 200 : 230,
                                                minHeight: isSm ? 270 : 300,
                                                maxHeight: isSm ? 270 : 300,
                                            }}
                                            values={_.get(form, 'values')}
                                            {...{name, value, onChange}}
                                        />
                                    </div>
                                )}
                            </Translate>
                        )}
                    </LayoutContext.Consumer>
                ),
            },
            {
                label: 'insignia',
                name: 'avatar',
                component: ({name, value, form, onChange}) => (
                    <LayoutContext.Consumer>
                        {({isSm}) => (
                            <Translate>
                                {(t) => (
                                    <div className="flex flex-col gap-2">
                                        <span className="text-xs text-color-500 italic">{`* ${t('description size insignia')}`}</span>
                                        <PhotoField
                                            Wrapper={({children}) => (
                                                <div className="flex flex-col flex-center relative">
                                                    {children}
                                                </div>
                                            )}
                                            className="background"
                                            cropPurpose="avatar"
                                            cropShape="rect"
                                            square
                                            style={{
                                                padding: 0,
                                                minWidth: isSm ? 100 : 180,
                                                minHeight: isSm ? 100 : 180,
                                                maxWidth: isSm ? 100 : 180,
                                                maxHeight: isSm ? 100 : 180,
                                            }}
                                            values={_.get(form, 'values')}
                                            {...{name, value, onChange}}
                                        />
                                    </div>
                                )}
                            </Translate>
                        )}
                    </LayoutContext.Consumer>
                ),
            },
        ],
    },
    date__place_of_birth: {
        inline: true,
        className: appClassNames.inline_2,
        children: [
            {
                label: 'date of birth',
                name: 'date_of_birth',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate}) => ({
                        name,
                        value,
                        className: 'w-full',
                        format: gConfigs.dateFormat,
                        suffixIcon: <IoCalendarOutline className="text-color-500"/>,
                        placeholder: `${translate('date of birth')} "DD/MM/YYYY"`,
                        // 🔹 Giới hạn ngày
                        disabledDate: (current) => {
                            const maxDate = dayjs().subtract(5, 'year');
                            const minDate = dayjs().subtract(2000, 'year');

                            return (
                                current &&
                                (current > maxDate.endOf('day') || current < minDate.startOf('day'))
                            );
                        },
                        // 🔹 mở lịch ở khoảng năm hợp lý
                        defaultPickerValue: value ?? dayjs().subtract(30, 'year'),
                        onChange: (date, dateString) => {
                            onChange(createValue(name, date ? dayjs(new Date(date)) : null))
                        },
                    }))
                )(DatePicker),
            },
            {
                label: 'place of birth',
                name: 'place_of_birth',
                component: createControlledFormField({
                    placeholder: 'place of birth',
                    Component: Input,
                }),
            },
        ],
    },
    date__place_of_death: {
        inline: true,
        className: appClassNames.inline_2,
        children: [
            {
                label: 'date of death',
                name: 'date_of_death',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate}) => ({
                        name,
                        value,
                        className: 'w-full',
                        format: gConfigs.dateFormat,
                        suffixIcon: <IoCalendarOutline className="text-color-500"/>,
                        placeholder: `${translate('date of death')} "DD/MM/YYYY"`,
                        onChange: (date, dateString) => {
                            onChange(createValue(name, date ? dayjs(new Date(date)) : null))
                        },
                    }))
                )(DatePicker),
            },
            {
                label: 'place of death',
                name: 'place_of_death',
                component: createControlledFormField({
                    placeholder: 'place of death',
                    Component: Input,
                }),
            },
        ],
    },
    nationality_country: {
        inline: true,
        className: appClassNames.inline_2,
        children: [
            {
                label: 'nationality',
                name: 'nationality_id',
                component: compose(
                    withProps({
                        allowClear: true
                    })
                )(CountryPicker),
            },
            {
                label: 'place of residence',
                name: 'country_id',
                component: compose(
                    withProps({
                        allowClear: true
                    })
                )(CountryPicker),
            },
        ],
    },
    memorial_date_feast_state: {
        inline: true,
        className: "flex flex-col gap-3",
        children: [
            {
                label: 'memorial date',
                name: 'feast_day',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate}) => ({
                        name,
                        className: 'w-full',
                        format: 'DD/MM',
                        suffixIcon: <IoCalendarOutline className="text-color-500"/>,
                        placeholder: "DD/MM",
                        defaultValue: parseDayjs(value ?? undefined),
                        onChange: (date, dateString) => {
                            onChange(createValue(name, date ? dayjs(date) : null))
                        },
                    }))
                )(DatePicker)
            },
            {
                label: 'feast state',
                name: 'feast_state',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate}) => {
                        const {isSm} = useContext(LayoutContext)
                        return {
                            name,
                            value,
                            onChange,
                            defaultValue: FeastStates.NONE,
                            buttonStyle: 'solid',
                            style: {
                                whiteSpace: isSm ? 'wrap' : 'nowrap',
                            },
                            className: 'w-full custom-radio-button-sm',
                            children: Object.values(FeastStates).filter((e) => e.value !== 'NONE').map(
                                ({name, value, label}) => (
                                    <Radio.Button
                                        key={name}
                                        style={{padding: '6px 8px', height: 32}}
                                        value={value}>
                                        {translate(label)}
                                    </Radio.Button>
                                )
                            ),
                        }
                    })
                )(Radio.Group),
            },
        ]
    },
    holy_doctor__group: {
        className: "flex flex-col gap-3",
        children: [
            {
                label: 'holy doctor date',
                name: 'holy_doctor_date',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate}) => ({
                        name,
                        value,
                        className: 'w-full',
                        format: 'DD/MM/YYYY',
                        suffixIcon: <IoCalendarOutline className="text-color-500"/>,
                        placeholder: "DD/MM/YYYY",
                        onChange: (date, dateString) => {
                            onChange(createValue(name, date ? dayjs(new Date(date)) : null))
                        },
                    }))
                )(DatePicker)
            },
        ]
    },
    position_title: {
        title: 'position title',
        children: [
            {
                name: 'position_title',
                component: ({name, value, onChange, form}) => {
                    const values = _.get(form, 'values', {})
                    return (
                        <Translate>
                            {(t) => (
                                <LookupField
                                    createIfNotExists={false}
                                    defaultValue={values?.position_title}
                                    apiPath={`/lookup/position_title/gets`}
                                    name={name}
                                    placeholder={t('click to select')}
                                    renderOption={(o, i) => {
                                        return (
                                            <div key={i} className="flex flex-col justify-center flex-1">
                        <span className="font-bold text-sm text-color-000 leading-snug">
                          {o.name}
                        </span>
                                                {renderIf(
                                                    o.description,
                                                    <span className="font-medium text-xs text-color-300 leading-tight">
                              {o.description}
                            </span>
                                                )}
                                            </div>
                                        )
                                    }}
                                    handleChange={(e) => {
                                        onChange(createValue('position_title', e.target.value))
                                    }}
                                />
                            )}
                        </Translate>
                    )
                },
            },
        ],
    },
    parish_diocese_location: {
        inline: true,
        className: 'grid grid-cols-2 gap-3',
        children: [
            {
                label: 'belong to parish',
                name: 'parish',
                component: ({name, value, onChange, form, ...restForm}) => {
                    return (
                        <LayoutContext.Consumer>
                            {({isSm}) => (
                                <Translate>
                                    {(t) => (
                                        <LookupField
                                            title={t('choose parish')}
                                            createIfNotExists={true}
                                            defaultValue={form?.values?.parish_name}
                                            selectedOption={form?.values?.parish}
                                            placeholder={t('click to select / create')}
                                            apiPath={`/lookup/parish/get-by-types`}
                                            name={name}
                                            OptionWrapper={({children, selected, ...props}) =>
                                                <div
                                                    className={classnames(
                                                        'flex items-center gap-3 rounded-xl cursor-pointer transition-all duration-150 overflow-hidden',
                                                        selected ? 'bg-primary-50 ring-1 ring-primary-200' : 'hover:bg-color-50'
                                                    )}
                                                    {...props}>
                                                    {children}
                                                </div>
                                            }
                                            renderOption={(o, i) => {
                                                const {fullname, diocese_fullname, location_address} = o ?? {}
                                                return (
                                                    <div key={i} className="flex items-center flex-1 gap-3 px-3 py-2.5">
                                                        {renderIf(
                                                            !isSm,
                                                            <Avatar
                                                                size={44}
                                                                src={o.avatar}
                                                                shape="square"
                                                                className="flex flex-center background-200 rounded-lg flex-shrink-0"
                                                                icon={<MdChurch size={18} style={{color: '#cccccc'}}/>}
                                                            />
                                                        )}
                                                        <div className="flex flex-col flex-1 min-w-0 gap-0.5">
                                                            <div className="flex items-center gap-1.5 flex-wrap">
                                                                <span className="font-semibold text-sm text-color-000 leading-snug">
                                                                    {fullname}
                                                                </span>
                                                                {diocese_fullname && (
                                                                    <span className="inline-flex px-1.5 py-0.5 rounded-full bg-blue-50 text-blue-500 text-2xs font-medium border border-blue-100 leading-tight whitespace-nowrap">
                                                                        {diocese_fullname}
                                                                    </span>
                                                                )}
                                                            </div>
                                                            {renderIf(
                                                                location_address,
                                                                <div className="flex items-center gap-x-1">
                                                                    <RiMapPinFill size={10} className="text-color-400 flex-shrink-0"/>
                                                                    <span className="text-xs text-color-400 leading-snug truncate">
                                                                        {location_address}
                                                                    </span>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )
                                            }}
                                            handleChange={(e) => {
                                                form.setValues({
                                                    ...form.values,
                                                    parish: e.target,
                                                    parish_name: e.target.value,
                                                    parish_id: e.target.id,
                                                    diocese: e.target.diocese,
                                                    diocese_name: e.target?.diocese?.name,
                                                    diocese_id: e.target?.diocese?.id
                                                });
                                            }}
                                        />
                                    )}
                                </Translate>
                            )}
                        </LayoutContext.Consumer>
                    )
                },
            },
            {
                label: 'belong to diocese',
                name: 'diocese',
                component: ({name, value, onChange, form, ...restForm}) => {
                    return (
                        <LayoutContext.Consumer>
                            {({isSm}) => (
                                <Translate>
                                    {(t) => (
                                        <LookupField
                                            title={t('choose diocese')}
                                            createIfNotExists={true}
                                            defaultValue={form?.values?.diocese_name}
                                            selectedOption={form?.values?.diocese}
                                            placeholder={t('click to select / create')}
                                            apiPath={`/lookup/diocese/get-by-types`}
                                            name={name}
                                            OptionWrapper={({children, ...props}) =>
                                                <div
                                                    className="flex items-center gap-2 border border-color-50 hover:shadow-md rounded-lg relative" {...props}>
                                                    {children}
                                                </div>
                                            }
                                            renderOption={(o, i) => {
                                                const {fullname, location_address} = o ?? {}
                                                return (
                                                    <div key={i} className="flex items-center flex-1 gap-3">
                                                        <Avatar
                                                            size={50}
                                                            src={o.avatar}
                                                            className="flex flex-center background-200 rounded-l-lg rounded-r-0"
                                                            icon={<MdChurch size={20} style={{color: '#dddddd'}}/>}
                                                        />
                                                        <div className="py-2 md:py-0 flex flex-col flex-1 min-w-0 gap-1">
                                                            <div className="space-x-1 leading-snug">
                                                              <span className="font-bold text-sm text-color-000">
                                                                  {fullname}
                                                              </span>
                                                            </div>
                                                            {renderIf(
                                                                location_address,
                                                                <div className="flex items-center gap-x-1">
                                                                    <RiMapPinFill size={11} className="text-color-400"/>
                                                                    <span
                                                                        className="flex-1 max-lines-1 text-xs text-color-400 italic leading-snug">
                                                                    {location_address}
                                                                  </span>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )
                                            }}
                                            handleChange={(e) => {
                                                form.setValues({
                                                    ...form.values,
                                                    diocese: e.target,
                                                    diocese_name: e.target.value,
                                                    diocese_id: e.target.id,
                                                });
                                            }}
                                        />
                                    )}
                                </Translate>
                            )}
                        </LayoutContext.Consumer>
                    )
                },
            },
        ],
    },
    profile_categories: {
        title: 'type',
        children: [
            {
                name: 'profile_categories',
                component: compose(
                    withTranslate,
                    mapProps(({name, translate, onChange, value, options}) => ({
                        name,
                        allowClear: true,
                        onChange: (value) => onChange(createSelectValue('profile_categories', value)),
                        value: value || undefined,
                        placeholder: translate('click to select'),
                        className: 'w-full',
                        mode: "multiple",
                        options: profileCategories.map(({label, value}) => ({
                            label: translate(label),
                            value: value,
                        }))
                    })),
                    pure
                )(SelectWidget),
            },
        ]
    },
}

// Tái dùng thẳng các component field phức tạp đã có sẵn trong formSchema (PhotoField,
// AliasNames, LookupField parish/diocese/position_title, CountryPicker, DatePicker...) thay vì
// viết lại - chỉ đổi phần khung ngoài (Section/Field) cho Create/EditProfileForm, không đụng
// logic input bên trong. Các component này đều nhận {name, value, form, onChange} - "form" cần
// {values, setValues} (Formik bag đã đúng shape này), "onChange" cần nhận event dạng
// createValue() = {target:{name,value}}.
const PhotoInput = formSchema.photo__insignia.children[0].component
const AvatarInput = formSchema.photo__insignia.children[1].component
const NameInput = formSchema.name.children[0].component
const AliasNamesInput = formSchema.alias_names.children[0].component
const DateOfBirthInput = formSchema.date__place_of_birth.children[0].component
const PlaceOfBirthInput = formSchema.date__place_of_birth.children[1].component
const DateOfDeathInput = formSchema.date__place_of_death.children[0].component
const PlaceOfDeathInput = formSchema.date__place_of_death.children[1].component
const NationalityInput = formSchema.nationality_country.children[0].component
const ResidenceCountryInput = formSchema.nationality_country.children[1].component
const HolyDoctorDateInput = formSchema.holy_doctor__group.children[0].component
const FeastDayInput = formSchema.memorial_date_feast_state.children[0].component
const PositionTitleInput = formSchema.position_title.children[0].component
const ParishInput = formSchema.parish_diocese_location.children[0].component
const DioceseInput = formSchema.parish_diocese_location.children[1].component
const BriefInput = formSchema.brief.children[0].component
const NotesInput = formSchema.notes.children[0].component
const AboutInput = formSchema.about.children[0].component

const PROFILE_CATEGORY_FIELDS = [
    'is_holy_doctor', 'is_martyr', 'is_saint', 'is_prelate',
    'is_philosopher', 'is_theologian', 'is_musician', 'is_lay_person', 'is_scientist',
]

// feast_state là danh sách cố định ít lựa chọn (4 bậc) - trước để nguyên Radio.Button màu xanh/tím
// của formSchema, đứng cạnh chip "Loại" (rose) nhìn lệch tông. Dùng ChipGroup dùng chung, đơn-chọn
// (bấm lại chip đang active -> bỏ chọn = FeastStates.NONE).
const FEAST_STATE_OPTIONS = Object.values(FeastStates).filter((e) => e.value !== FeastStates.NONE.value)

// Các cấp trong tiến trình phong thánh, từ thấp đến cao — dùng để phân biệt
// "nhân vật" (không có feast_state / NONE) với "thánh nhân" đang ở từng cấp bậc.
const FeastTierColors = {
    SAINT: 'bg-amber-400 text-amber-900',
    BLESSED: 'bg-indigo-100 text-indigo-600',
    VENERABLE: 'bg-teal-100 text-teal-700',
    SERVANT_OF_GOD: 'bg-color-100 text-color-500',
}

const FeastTierBadge = ({feast_state, shapeClassName = 'px-2 py-0.5 rounded-full text-2xs font-medium tracking-wide'}) => {
    const t = useTranslate()
    if (!feast_state || feast_state === 'NONE') return null
    const label = _.find(FeastStates, {value: feast_state})?.label
    return (
        <span className={classnames(shapeClassName, FeastTierColors[feast_state] ?? 'bg-color-100 text-color-500')}>
            {t(label)}
        </span>
    )
}

// Mỗi phần nội dung (motto, bổn mạng, thông tin nhân thân...) gói vào 1 card nền sáng
// riêng biệt — 1 tông màu duy nhất (teal, đồng bộ với header) thay vì mỗi card 1 màu
// khác nhau (đã bị nhận xét "màu sắc quá") để giữ cảm giác gọn gàng, sang trọng.
const SectionCard = ({icon, title, children, className}) => (
    <div className={classnames('rounded-xl background-100 p-3 md:p-4 flex flex-col gap-3', className)}>
        <div className="flex items-center gap-2">
            <span className="flex flex-center text-teal-700">{icon}</span>
            <span className="font-semibold text-xs md:text-sm text-color-300 uppercase tracking-wider">
                {title}
            </span>
        </div>
        <div className="flex flex-col gap-2 pl-1">{children}</div>
    </div>
)

// Số 0 ở year_of_birth/year_of_death/năm phong... là giá trị mặc định "chưa có dữ liệu",
// không phải năm 0 thật — lọc ra để tránh hiện "Năm mất : 0" như báo cáo thực tế.
const hasYear = (y) => !!y && Number(y) > 0

// Hàng thông tin label/value canh đều theo 1 cột cố định — thay cho ItemInformation/
// DatePlaceItem nối chuỗi tự do (đã bị nhận xét "khoảng cách không đều, nội dung lệch nhau").
const InfoRow = ({label, value}) => (
    <div className="flex items-baseline gap-2">
        <span className="w-28 flex-shrink-0 text-xs text-color-400 italic">{label}</span>
        <span className="flex-1 text-sm font-semibold text-color-100 leading-snug">{value}</span>
    </div>
)

export const DetailForm = ({reportAccess = false, item, onCancel}) => {
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)
    const [current, setCurrent] = useState('overview')

    const {
        id,
        name,
        common_name,
        photo,
        date_of_birth,
        place_of_birth,
        date_of_death,
        place_of_death,
        year_of_beatification,
        year_of_birth,
        year_of_canonization,
        year_of_death,
        brief,
        description,
        about,
        profile_biographies = [],
        feast_state,
        feast_day, patron_saint_feast_day,
        nationality,
        country,
        profile_category_codes,
        date_of_beatification,
        date_of_canonization,
        holy_doctor_date,
        holy_doctor_year,
        is_holy_doctor,
        is_martyr,
        position_title,
        notes,
        insignia,
    } = item ?? {}


    const hasBirthYear = hasYear(year_of_birth)
    const hasDeathYear = hasYear(year_of_death)
    const hasBeatificationYear = hasYear(year_of_beatification)
    const hasCanonizationYear = hasYear(year_of_canonization)
    const hasHolyDoctorYear = hasYear(holy_doctor_year)

    const InformationTab = () => (
        <div className="flex flex-col gap-3">
            {renderIf(
                brief,
                <SectionCard icon={<RiDoubleQuotesL size={15}/>} title={t('motto')}>
                    <div className="font-semibold text-base text-color-000 italic leading-relaxed">
                        <RiDoubleQuotesL size={8} className="mr-1 mb-1 text-teal-600"/>
                        {brief}
                        <RiDoubleQuotesR size={8} className="ml-1 mb-1 text-teal-600"/>
                    </div>
                </SectionCard>
            )}
            {renderIf(
                _.some([feast_day, patron_saint_feast_day, date_of_beatification, date_of_canonization, hasBeatificationYear, hasCanonizationYear]),
                <SectionCard icon={<GiIronCross size={14}/>} title={t('anniversary')}>
                    {(feast_day || patron_saint_feast_day) && (
                        <div className="rounded-lg bg-teal-50 px-3 py-2 flex items-center justify-between gap-2">
                            <span className="text-xs text-teal-600 italic">{t('feast day')}</span>
                            <span className="font-bold text-sm text-teal-800">
                                {feast_day || patron_saint_feast_day}
                            </span>
                        </div>
                    )}
                    {renderIf(
                        _.some([date_of_beatification, hasBeatificationYear]),
                        <InfoRow
                            label={t('date of beatification')}
                            value={formatDate(date_of_beatification, 'DD/MM/YYYY') || year_of_beatification}
                        />
                    )}
                    {renderIf(
                        _.some([date_of_canonization, hasCanonizationYear]),
                        <InfoRow
                            label={t('date of canonization')}
                            value={formatDate(date_of_canonization, 'DD/MM/YYYY') || year_of_canonization}
                        />
                    )}
                    {renderIf(
                        _.some([holy_doctor_date, hasHolyDoctorYear]),
                        <InfoRow
                            label={t('date of holy doctor')}
                            value={formatDate(holy_doctor_date, 'DD/MM/YYYY') || holy_doctor_year}
                        />
                    )}
                </SectionCard>
            )}
            {renderIf(
                _.some([date_of_birth, hasBirthYear, nationality, place_of_birth, date_of_death, hasDeathYear, country, place_of_death]),
                <SectionCard icon={<BsPersonLinesFill size={14}/>} title={t('personal information')}>
                    {renderIf(
                        _.some([date_of_birth, hasBirthYear, place_of_birth]),
                        <InfoRow
                            label={t(date_of_birth ? 'date of birth' : 'year of birth')}
                            value={
                                <>
                                    {date_of_birth ? formatDate(date_of_birth, 'DD/MM/YYYY') : (hasBirthYear ? year_of_birth : null)}
                                    {place_of_birth && (
                                        <span className="font-normal text-color-400">{` · ${place_of_birth}`}</span>
                                    )}
                                </>
                            }
                        />
                    )}
                    {renderIf(
                        nationality,
                        <InfoRow label={t('nationality')} value={nationality?.location_name}/>
                    )}
                    {renderIf(
                        _.some([date_of_death, hasDeathYear, place_of_death]),
                        <InfoRow
                            label={t(date_of_death ? 'date of death' : 'year of death')}
                            value={
                                <>
                                    {date_of_death ? formatDate(date_of_death, 'DD/MM/YYYY') : (hasDeathYear ? year_of_death : null)}
                                    {place_of_death && (
                                        <span className="font-normal text-color-400">{` · ${place_of_death}`}</span>
                                    )}
                                </>
                            }
                        />
                    )}
                    {renderIf(
                        country,
                        <InfoRow label={t('place of residence')} value={country?.location_name}/>
                    )}
                </SectionCard>
            )}
        </div>
    )

    // Mốc phong thánh (nếu có) hiển thị nối tiếp career timeline, cùng style chấm tròn —
    // giúp "phân tách các cấp": nhân vật thường chỉ có career, thánh nhân có thêm các mốc này.
    const canonizationMilestones = [
        (holy_doctor_date || holy_doctor_year) && {
            dateLabel: 'date of holy doctor',
            dateValue: holy_doctor_date ? formatDate(holy_doctor_date, 'DD/MM/YYYY') : holy_doctor_year,
            title: 'doctor of church',
        },
        (date_of_beatification || year_of_beatification) && {
            dateLabel: 'date of beatification',
            dateValue: date_of_beatification ? formatDate(date_of_beatification, 'DD/MM/YYYY') : year_of_beatification,
            title: 'blessed',
        },
        (date_of_canonization || year_of_canonization) && {
            dateLabel: 'date of canonization',
            dateValue: date_of_canonization ? formatDate(date_of_canonization, 'DD/MM/YYYY') : year_of_canonization,
            title: 'saint',
        },
    ].filter(Boolean)

    const BiographyTab = () => (
        renderIfElse(
            _.some([profile_biographies.length > 0, canonizationMilestones.length > 0]),
            <SectionCard
                icon={<BsPersonWorkspace size={14}/>}
                title={t(canonizationMilestones.length > 0 ? 'canonization process' : 'detail biography')}>
                <div className="space-y-3">
                    {profile_biographies.map((e, i) => {
                        const {
                            start_date,
                            start_year,
                            end_date,
                            end_year,
                            position_title,
                            location,
                            assign_action
                        } = e ?? {}

                        return (
                            <div key={i} className="create-my-timeline">
                                <div style={{marginTop: 5}} className="flex flex-col items-center gap-1">
                                    <FaCircle size={9} className="timeline-icon text-primary-400"/>
                                    <div className="timeline-tail flex-1"/>
                                </div>
                                <div className="flex flex-col gap-1">
                                    <div className="flex items-baseline gap-x-2 leading-tight">
                                        <div className="flex items-baseline gap-2">
                    <span className="text-xs text-color-500 italic">
                      {t('from')}
                    </span>
                                            {renderIfElse(
                                                _.some([start_date, start_year]),
                                                <span className="font-bold text-sm text-color-000">
                          {renderIfElse(
                              start_date,
                              formatDate(start_date, 'DD/MM/YYYY'),
                              `${_.capitalize(t('years'))} ${start_year}`
                          )}
                        </span>,
                                                <span className="font-semibold text-xs text-color-100">
                          {t('not update')}
                        </span>
                                            )}
                                        </div>
                                        {renderIf(
                                            _.some([end_date, end_year]),
                                            <div className="flex items-baseline gap-2">
                        <span className="text-xs text-color-500 italic">
                          {t('to')}
                        </span>
                                                <span className="font-bold text-sm text-color-000">
                          {renderIfElse(
                              end_date,
                              formatDate(end_date, 'DD/MM/YYYY'),
                              `${_.capitalize(t('years'))} ${end_year}`
                          )}
                        </span>
                                            </div>
                                        )}
                                    </div>
                                    <div className="space-x-2 leading-snug">
                  <span className="text-xs text-color-500 italic">
                    {t(assign_action ? assign_action : 'hold a position')}
                  </span>
                                        <span className="font-semibold text-sm text-blue-600">
                    {t(position_title)}
                  </span>
                                        {e.location && (
                                            <>
                        <span className="text-xs text-color-500 italic">
                          {t('in')}
                        </span>
                                                <span className="font-semibold text-sm text-color-100">
                          {location}
                        </span>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                    {canonizationMilestones.map((e, i) => (
                        <div key={`milestone-${i}`} className="create-my-timeline">
                            <div style={{marginTop: 5}} className="flex flex-col items-center gap-1">
                                <FaCircle size={9} className="timeline-icon text-amber-500"/>
                                <div className="timeline-tail flex-1"/>
                            </div>
                            <div className="flex flex-col gap-1">
                                <div className="flex items-baseline gap-2">
                                    <span className="text-xs text-color-500 italic">{t(e.dateLabel)}</span>
                                    <span className="font-bold text-sm text-color-000">{e.dateValue}</span>
                                </div>
                                <span className="font-semibold text-sm text-amber-600">{t(e.title)}</span>
                            </div>
                        </div>
                    ))}
                </div>
            </SectionCard>,
            <EmptyHolder iconSize={40}/>
        )
    )

    const AboutCharacterTab = () => (
        renderIfElse(
            _.some([description, !isRawContentEmpty(about)]),
            <SectionCard icon={<BsPersonWorkspace size={14}/>} title={t('about character')}>
                <div className="text-sm leading-relaxed space-y-2">
                    {renderIf(
                        description,
                        <div className="pl-2 text-color-100 italic">
                            {description}
                        </div>
                    )}
                    {renderIf(
                        !isRawContentEmpty(about),
                        <SlateRenderer className="prose prose-sm max-w-none" value={convertFromString(about)}/>,
                    )}
                </div>
            </SectionCard>,
            <EmptyHolder/>
        )
    )

    const tabs = [
        {
            key: 'overview',
            label: t('overview'),
            content: <InformationTab/>,
        },
        {
            key: 'biography',
            label: t('biography'),
            content: <BiographyTab/>,
        },
        {
            key: 'legacy',
            label: t('legacy'),
            content: <AboutCharacterTab/>,
        },
    ]

    const {reportModal, handleReport} = useFeedback({
        notifyListeners: {}
    })

    return (
        <div className="flex flex-col gap-3">
            <div
                className="relative overflow-hidden -mx-4 -mt-2 flex flex-col flex-center gap-2 pt-6 pb-4 px-4"
                style={{background: 'linear-gradient(135deg, #0f766e 0%, #042f2e 100%)'}}>
                <div
                    className="absolute inset-0 pointer-events-none opacity-10"
                    style={{
                        backgroundImage: 'radial-gradient(circle at 20% 20%, #ffffff 0%, transparent 40%), radial-gradient(circle at 80% 80%, #ffffff 0%, transparent 40%)',
                    }}
                />
                <div
                    style={{width: isSm ? 84 : 104, height: isSm ? 84 : 104}}
                    className="relative flex flex-center bg-white rounded-full shadow-lg border-2 border-white overflow-hidden">
                    {renderIfElse(
                        photo,
                        <img
                            src={photo}
                            alt={common_name || name}
                            style={{width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'top'}}
                        />,
                        <SaintsFillSvg size={54} style={{color: '#dddddd'}}/>
                    )}
                </div>
                <div className="relative flex flex-col flex-center gap-1 px-4">
                    <div
                        className="text-center font-bold text-lg md:text-xl text-white uppercase tracking-wide leading-tight">
                        {common_name ? common_name : name}
                    </div>
                    {renderIf(
                        _.some([common_name, feast_day, patron_saint_feast_day]),
                        <div className="flex flex-col items-center gap-1">
                            {renderIf(
                                common_name,
                                <div className="flex items-center gap-2 tracking-wider">
                                    <span
                                        className="text-xs text-white text-opacity-70 whitespace-no-wrap italic">{`${t('real name')} : `}</span>
                                    <span style={{fontSize: 15}} className="font-bold text-white leading-tight">
                        {name}
                      </span>
                                </div>
                            )}
                            {renderIf(
                                feast_day || patron_saint_feast_day,
                                <div className="flex items-center gap-2 tracking-wider">
                                    <span
                                        className="text-xs text-white text-opacity-70 whitespace-no-wrap italic">{`${t('feast day')} : `}</span>
                                    <span style={{fontSize: 15}} className="font-bold text-white leading-tight">
                        {patron_saint_feast_day || feast_day}
                      </span>
                                </div>
                            )}
                        </div>
                    )}
                    <div className="flex flex-wrap flex-center gap-1 mt-1">
                        {renderIf(
                            is_martyr === 1,
                            <span
                                style={{backgroundColor: 'rgba(255,255,255,0.15)'}}
                                className="px-2 py-0.5 text-white font-medium text-2xs rounded-full tracking-wide">
                  {t('martyr')}
                </span>
                        )}
                        {renderIf(
                            is_holy_doctor === 1,
                            <span
                                style={{backgroundColor: 'rgba(255,255,255,0.15)'}}
                                className="px-2 py-0.5 text-white font-medium text-2xs rounded-full tracking-wide">
                  {t('doctor of church')}
                </span>
                        )}
                        {renderIf(
                            position_title,
                            <span
                                className="px-2 py-0.5 bg-amber-400 text-amber-900 font-medium text-2xs rounded-full tracking-wide">
                                {t(position_title || '')}
                            </span>
                        )}
                        <FeastTierBadge feast_state={feast_state}/>
                    </div>
                </div>
            </div>
            <div className="w-full flex">
                <div className="flex-1"/>
                <div className="flex items-center gap-x-2">
                    <span className="text-xs text-color-400 italic leading-snug">
                        {`${t('share')} : `}
                    </span>
                    <HeaderButton
                        onClick={() => {
                            callNativeShare({title: getTitle(item), url: getAbsoluteLinkToDetail(item)})
                        }}
                        width={24}
                        height={24}
                        icon={<RiShareForwardFill size={12}/>}
                    />
                    <HeaderButton
                        onClick={() => {
                            copyToClipboard(getAbsoluteLinkToDetail(item))
                            message.success(t('copied'))
                        }}
                        width={24}
                        height={24}
                        icon={
                            <PiLinkSimpleBold size={12}/>
                        }
                    />
                </div>
            </div>
            <Tabs
                centered
                size="small"
                activeKey={current}
                onChange={setCurrent}
                items={tabs.map((e) => ({
                    key: e.key,
                    label: <span className="font-medium text-sm">{e.label}</span>,
                    children: e.content,
                }))}
            />
            <div className="flex items-center justify-between px-1 py-3 mt-2 gap-6">
                {renderIfElse(
                    reportAccess === true,
                    <div className="flex flex-col">
                        <div
                            onClick={() => {
                                handleReport({
                                    ref_type: 'profile',
                                    ref_id: id,
                                    feedback_category_id: 'character-information'
                                })
                            }}
                            className="flex items-center flex-1 gap-2 text-orange-300 hover:text-orange-500 cursor-pointer">
                            <PiWarningDuotone size={15} className="text-orange-500"/>
                            <span className="font-medium text-sm italic">{t('leave a feedback')}</span>
                        </div>
                        <div className="text-xs text-color-500 italic leading-snug">
                            {`* ${t('send update profile description')}`}
                        </div>
                    </div>,
                    <div className="flex-1"/>
                )}
            </div>
            {reportAccess === true && reportModal}
        </div>
    )
}

export const CreateProfileForm = ({
                                      category_code,
                                      onCancel = NullAsDefault,
                                      onSubmit = NullAsDefault,
                                  }) => {
    const t = useTranslate()
    const validate = (values) => {
        let errors = {}
        if (_.isEmpty(_.get(values, 'name') ?? undefined)) {
            errors.name = t('required field')
        }
        return errors
    }
    const initialValues = {
        name: undefined,
        feast_state: FeastStates.NONE.value,
    }
    return (
        <Formik
            initialValues={initialValues}
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            onSubmit={({date_of_birth, date_of_death, holy_doctor_date, feast_day, alias_names, ...values}) => {
                const changes = shallowDiff(values, initialValues)
                const categoryFields = PROFILE_CATEGORY_FIELDS.reduce((acc, field) => {
                    acc[field] = values.profile_categories?.includes(field) ? 1 : 0;
                    return acc;
                }, {});
                onSubmit(_.omitBy(
                    {
                        ...changes,
                        ...categoryFields,
                        alias_names: !!!_.isEmpty(alias_names) ? JSON.stringify(alias_names) : undefined,
                        feast_day: !!feast_day ? formatDate(feast_day, "DD/MM") : undefined,
                        date_of_birth: !!date_of_birth ? getDateString(date_of_birth) : undefined,
                        date_of_death: !!date_of_birth ? getDateString(date_of_death) : undefined,
                        holy_doctor_date: !!date_of_birth ? getDateString(holy_doctor_date) : undefined,
                    },
                    _.isUndefined
                ))
            }}>
            {(formik) => {
                const {values, touched, errors, setFieldValue, handleSubmit, isSubmitting, isValid} = formik
                const onChange = (e) => setFieldValue(e.target.name, e.target.value)
                const profileCats = Array.isArray(values?.profile_categories) ? values.profile_categories : []

                return (
                    <form onSubmit={handleSubmit} className="flex flex-col gap-4">
                        <Section icon={IoImageOutline} title={t('portrait photo')} subtitle={t('optional')}>
                            <div className="grid grid-cols-1 gap-3">
                                <PhotoInput name="photo" value={values.photo} form={formik} onChange={onChange}/>
                                <AvatarInput name="avatar" value={values.avatar} form={formik} onChange={onChange}/>
                            </div>
                        </Section>

                        <Section icon={IoPersonOutline} title={t('real name')} theme="highlight">
                            <Field label={t('real name')} required error={touched.name && errors.name}>
                                <NameInput name="name" value={values.name} onChange={onChange}/>
                            </Field>
                        </Section>

                        <Section icon={IoPricetagOutline} title={t('common name')} subtitle={t('optional')}>
                            <AliasNamesInput name="alias_names" value={values.alias_names} onChange={onChange}/>
                        </Section>

                        <Section icon={IoCalendarOutline} title={t('date of birth')} subtitle={t('optional')}>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                <Field label={t('date of birth')}>
                                    <DateOfBirthInput name="date_of_birth" value={values.date_of_birth} onChange={onChange}/>
                                </Field>
                                <Field label={t('place of birth')}>
                                    <PlaceOfBirthInput name="place_of_birth" value={values.place_of_birth} onChange={onChange}/>
                                </Field>
                            </div>
                        </Section>

                        <Section icon={IoEarthOutline} title={t('nationality')} subtitle={t('optional')}>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                <Field label={t('nationality')}>
                                    <NationalityInput name="nationality_id" value={values.nationality_id} form={formik} allowClear/>
                                </Field>
                                <Field label={t('place of residence')}>
                                    <ResidenceCountryInput name="country_id" value={values.country_id} form={formik} allowClear/>
                                </Field>
                            </div>
                        </Section>

                        <Section icon={IoCalendarOutline} title={t('date of death')} subtitle={t('optional, leave blank if still alive')}>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                <Field label={t('date of death')}>
                                    <DateOfDeathInput name="date_of_death" value={values.date_of_death} onChange={onChange}/>
                                </Field>
                                <Field label={t('place of death')}>
                                    <PlaceOfDeathInput name="place_of_death" value={values.place_of_death} onChange={onChange}/>
                                </Field>
                            </div>
                        </Section>

                        <Section icon={IoRibbonOutline} title={t('type')} subtitle={t('optional, may select more than one')}>
                            <ChipGroup
                                multiple
                                options={profileCategories}
                                value={profileCats}
                                onChange={(next) => setFieldValue('profile_categories', next)}
                            />
                        </Section>

                        {profileCats.includes('is_holy_doctor') && (
                            <Section icon={IoSchoolOutline} title={t('holy doctor date')}>
                                <HolyDoctorDateInput name="holy_doctor_date" value={values.holy_doctor_date} onChange={onChange}/>
                            </Section>
                        )}

                        {profileCats.includes('is_saint') && (
                            <Section icon={IoStarOutline} title={t('memorial date')}>
                                <div className="grid grid-cols-1 gap-3">
                                    <Field label={t('memorial date')}>
                                        <FeastDayInput name="feast_day" value={values.feast_day} onChange={onChange}/>
                                    </Field>
                                    <Field label={t('feast state')}>
                                        <ChipGroup options={FEAST_STATE_OPTIONS} value={values.feast_state} onChange={(v) => setFieldValue('feast_state', v)} unselectValue={FeastStates.NONE.value}/>
                                    </Field>
                                </div>
                            </Section>
                        )}

                        {profileCats.includes('is_prelate') && (
                            <Section icon={IoBusinessOutline} title={t('position title')}>
                                <PositionTitleInput name="position_title" value={values.position_title} form={formik} onChange={onChange}/>
                            </Section>
                        )}

                        <FormActions onCancel={onCancel} submitText="create" isSubmitting={isSubmitting} isValid={isValid}/>
                    </form>
                )
            }}
        </Formik>
    )
}

// ActionModalWrapper dùng field.component làm React component TYPE (const Component =
// field.component; <Component/>), không phải render-prop thường - định nghĩa inline trong render
// (như closure đóng qua formik.values) sẽ tạo function reference mới mỗi keystroke, khiến React
// remount toàn bộ cây con của tab đang active mỗi lần gõ (mất focus input, LookupField gọi lại API
// liên tục). Phải hoist ra module scope + tự đọc live values qua useFormikContext() bên trong,
// xem comment gốc + case đã fix ở YellowPageForm.js/ParishForm.js (ParishEditChurchesTab).
const ProfileEditOverviewTab = ({child}) => child

const ProfileEditPositionTab = () => {
    const t = useTranslate()
    const formik = useFormikContext()
    const {values, setFieldValue} = formik
    const onChange = (e) => setFieldValue(e.target.name, e.target.value)
    const profileCats = Array.isArray(values?.profile_categories) ? values.profile_categories : []

    return (
        <div className="flex flex-col gap-4">
            <Section icon={RiDoubleQuotesL} title={t('motto')} subtitle={t('optional')}>
                <BriefInput name="brief" value={values.brief} onChange={onChange}/>
            </Section>

            <Section icon={IoRibbonOutline} title={t('type')} subtitle={t('optional, may select more than one')}>
                <ChipGroup
                    multiple
                    options={profileCategories}
                    value={profileCats}
                    onChange={(next) => setFieldValue('profile_categories', next)}
                />
            </Section>

            {profileCats.includes('is_holy_doctor') && (
                <Section icon={IoSchoolOutline} title={t('holy doctor date')}>
                    <HolyDoctorDateInput name="holy_doctor_date" value={values.holy_doctor_date} onChange={onChange}/>
                </Section>
            )}

            {profileCats.includes('is_saint') && (
                <Section icon={IoStarOutline} title={t('memorial date')}>
                    <div className="grid grid-cols-1 gap-3">
                        <Field label={t('memorial date')}>
                            <FeastDayInput name="feast_day" value={values.feast_day} onChange={onChange}/>
                        </Field>
                        <Field label={t('feast state')}>
                            <ChipGroup options={FEAST_STATE_OPTIONS} value={values.feast_state} onChange={(v) => setFieldValue('feast_state', v)} unselectValue={FeastStates.NONE.value}/>
                        </Field>
                    </div>
                </Section>
            )}

            {profileCats.includes('is_prelate') && (
                <Section icon={IoBusinessOutline} title={t('position title')}>
                    <PositionTitleInput name="position_title" value={values.position_title} form={formik} onChange={onChange}/>
                </Section>
            )}
        </div>
    )
}

const ProfileEditAboutTab = () => {
    const t = useTranslate()
    const {values, setFieldValue} = useFormikContext()
    const onChange = (e) => setFieldValue(e.target.name, e.target.value)

    return (
        <div className="flex flex-col gap-4">
            <Section icon={BsPersonLinesFill} title={t('about character')} subtitle={t('optional')}>
                <AboutInput name="about" value={values.about} onChange={onChange}/>
            </Section>
            <RequiredSystemAdmin>
                <Section icon={PiWarningDuotone} title={t('notes')} subtitle={t('admin only')}>
                    <NotesInput name="notes" value={values.notes} onChange={onChange}/>
                </Section>
            </RequiredSystemAdmin>
        </div>
    )
}

export const EditProfileForm = ({
                                    item,
                                    initialValues,
                                    onCancel = NullAsDefault,
                                    onSubmit = NullAsDefault,
                                }) => {
    const t = useTranslate()
    const [current, setCurrent] = useState('overview');

    const {date_of_birth, date_of_death, holy_doctor_date, feast_day} = initialValues ?? {}

    const _initialValues = {
        ...initialValues,
        name: _.get(initialValues, 'name', ''),
        common_name: _.get(initialValues, 'common_name', ''),
        brief: _.get(initialValues, 'brief', ''),
        feast_state: _.get(initialValues, 'feast_state', 'NONE'),
        profile_category_code: _.get(initialValues, 'profile_category_code', 'SAINTS'),
        profile_categories: PROFILE_CATEGORY_FIELDS.filter((field) => initialValues[field] == 1),
        country_id: _.get(initialValues, 'country.id', null),
        nationality_id: _.get(initialValues, 'nationality.id', null),
        place_of_birth: _.get(initialValues, 'place_of_birth', ''),
        place_of_death: _.get(initialValues, 'place_of_death', ''),
        feast_day: !!feast_day ? formatDate(feast_day, 'DD/MM') : null,
        about: convertFromString(_.get(initialValues, 'about')),
        avatar: _.get(initialValues, 'avatar', ''),
        photo: _.get(initialValues, 'photo', ''),
        date_of_birth: String(date_of_birth ?? '').length > 0 ? parseDayjs(date_of_birth) : undefined,
        date_of_death: String(date_of_death ?? '').length > 0 ? parseDayjs(date_of_death) : undefined,
        holy_doctor_date: String(holy_doctor_date ?? '').length > 0 ? parseDayjs(holy_doctor_date) : undefined,

        parish: _.get(initialValues, 'parish', ''),
        parish_id: _.get(initialValues, 'parish.id', ''),
        parish_name: _.get(initialValues, 'parish_name', ''),
        diocese: _.get(initialValues, 'diocese', ''),
        diocese_id: _.get(initialValues, 'diocese.id', ''),
        diocese_name: _.get(initialValues, 'diocese_name', ''),
    }
    const validate = (values) => {
        let errors = {}
        if (_.isEmpty(_.get(values, 'name') ?? undefined)) {
            errors.name = t('required field')
        }
        return errors
    }

    return (
        <Formik
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={_initialValues}
            onSubmit={({date_of_birth, date_of_death, holy_doctor_date, feast_day, about, avatar_preview, photo_preview, alias_names, ...values}) => {
                const changes = shallowDiff(values, _initialValues)
                const categoryFields = PROFILE_CATEGORY_FIELDS.reduce((acc, field) => {
                    acc[field] = values.profile_categories?.includes(field) ? 1 : 0;
                    return acc;
                }, {});
                onSubmit({
                    ...changes,
                    ...categoryFields,
                    alias_names: !!!_.isEmpty(alias_names) ? JSON.stringify(alias_names) : undefined,
                    about: about ? convertToString(about) : undefined,
                    date_of_birth: getDateString(date_of_birth),
                    date_of_death: getDateString(date_of_death),
                    holy_doctor_date: getDateString(holy_doctor_date),
                    feast_day: formatDate(feast_day, "DD/MM"),
                })
            }}>
            {(formik) => {
                const {values, touched, errors, setFieldValue} = formik
                const onChange = (e) => setFieldValue(e.target.name, e.target.value)

                const overviewContent = (
                    <div className="flex flex-col gap-4">
                        <Section icon={IoImageOutline} title={t('portrait photo')} subtitle={t('optional')}>
                            <div className="grid grid-cols-1 gap-3">
                                <PhotoInput name="photo" value={values.photo} form={formik} onChange={onChange}/>
                                <AvatarInput name="avatar" value={values.avatar} form={formik} onChange={onChange}/>
                            </div>
                        </Section>

                        <Section icon={IoPersonOutline} title={t('real name')} theme="highlight">
                            <Field label={t('real name')} required error={touched.name && errors.name}>
                                <NameInput name="name" value={values.name} onChange={onChange}/>
                            </Field>
                        </Section>

                        <Section icon={IoPricetagOutline} title={t('common name')} subtitle={t('optional')}>
                            <AliasNamesInput name="alias_names" value={values.alias_names} onChange={onChange}/>
                        </Section>

                        <Section icon={IoCalendarOutline} title={t('date of birth')} subtitle={t('optional')}>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                <Field label={t('date of birth')}>
                                    <DateOfBirthInput name="date_of_birth" value={values.date_of_birth} onChange={onChange}/>
                                </Field>
                                <Field label={t('place of birth')}>
                                    <PlaceOfBirthInput name="place_of_birth" value={values.place_of_birth} onChange={onChange}/>
                                </Field>
                            </div>
                        </Section>

                        <Section icon={IoEarthOutline} title={t('nationality')} subtitle={t('optional')}>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                <Field label={t('nationality')}>
                                    <NationalityInput name="nationality_id" value={values.nationality_id} form={formik}/>
                                </Field>
                                <Field label={t('place of residence')}>
                                    <ResidenceCountryInput name="country_id" value={values.country_id} form={formik}/>
                                </Field>
                            </div>
                        </Section>

                        <Section icon={IoCalendarOutline} title={t('date of death')} subtitle={t('optional, leave blank if still alive')}>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                <Field label={t('date of death')}>
                                    <DateOfDeathInput name="date_of_death" value={values.date_of_death} onChange={onChange}/>
                                </Field>
                                <Field label={t('place of death')}>
                                    <PlaceOfDeathInput name="place_of_death" value={values.place_of_death} onChange={onChange}/>
                                </Field>
                            </div>
                        </Section>

                        <Section icon={MdChurch} title={t('belong to parish')} subtitle={t('optional')}>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                <Field label={t('belong to parish')}>
                                    <ParishInput name="parish" value={values.parish} form={formik}/>
                                </Field>
                                <Field label={t('belong to diocese')}>
                                    <DioceseInput name="diocese" value={values.diocese} form={formik}/>
                                </Field>
                            </div>
                        </Section>
                    </div>
                )

                return (
                    <ActionModalWrapper
                        tab={current}
                        action={<FormActionBar submitText="save"/>}
                        onTabChange={(key) => setCurrent(key)}
                        tabs={[
                            {key: 'overview', label: 'overview', component: ProfileEditOverviewTab},
                            {key: 'position', label: 'position - feast state', component: ProfileEditPositionTab},
                            {key: 'about', label: 'about character', component: ProfileEditAboutTab},
                        ]}>
                        {overviewContent}
                    </ActionModalWrapper>
                )
            }}
        </Formik>
    )
}

